module.exports = __webpack_public_path__ + "img/pre_info_bottom.ec77cc1a.png";